<template>
  <div>
    <v-container>
      <v-card class="mb-12" color="lighten-1">
       
        <v-data-table
          :headers="$t('app.invoices_headers')"
          :search="search"
          :items="$store.state.invoices"
          :items-per-page="20"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
                            <v-spacer></v-spacer>
               <v-text-field
            v-model="search"
                   append-icon="mdi-magnify"

            :label="$t('app.search')"
            single-line
           
          ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>
                  <v-btn fab dark small color="primary" @click="showInvoice(item['.key'])">
                  <v-icon dark>mdi-eye</v-icon></v-btn>
              </td>
              <td>{{item.invoice.number}}</td>
              <td>{{item.invoice.date}}</td>
              <td>{{item.invoice.to.name}}</td>
              <td>{{item.invoice.sub_total }}</td>
               <td>{{item.invoice.total }}</td>
                <td>{{item.invoice.currency }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { mapActions } from "vuex";

import { db } from "../../firebase";

export default {
  name: "ReceivedInvoice",
  components: {},
  data() {
    return {
      search :"",
      items: []
    };
  },
  firestore () {
     return {
      items: db.collection('userInvoices').where("invoice.to.email", "==", this.$store.state.user.email)
     }
  },
  mounted() {
    this.toogleSidebar(true);
    this.setUserInvoices(this.items)
  },
  methods: {
    ...mapActions(["toogleFetching", "toogleSidebar","initStepper",'setUserInvoices']),
    deleteProduct(id) {
      db.collection("userInvoices")
        .doc(id)
        .delete();
    },
    showInvoice(id){
            this.$router.push({ 
                name :'invoice.show',params : {id : id}
            })
    }
  }
};
</script>

<style scoped>
</style>